import { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);
const KEY = "pgc_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch {
      return [];
    }
  });

  useEffect(() => localStorage.setItem(KEY, JSON.stringify(items)), [items]);

  const add = (offer, qty = 1) =>
    setItems((prev) => {
      const found = prev.find((i) => i.offer.id === offer.id);
      if (found) return prev.map((i) => (i.offer.id === offer.id ? { ...i, qty: Math.min(i.qty + qty, offer.stock) } : i));
      return [...prev, { offer, qty }];
    });
  const setQty = (id, qty) => setItems((prev) => prev.map((i) => (i.offer.id === id ? { ...i, qty: Math.max(1, qty) } : i)));
  const remove = (id) => setItems((prev) => prev.filter((i) => i.offer.id !== id));
  const clear = () => setItems([]);
  const count = items.reduce((s, i) => s + i.qty, 0);

  return <CartCtx.Provider value={{ items, add, setQty, remove, clear, count }}>{children}</CartCtx.Provider>;
}

export const useCart = () => useContext(CartCtx);
